import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export interface Version {
  branch?: string
  buildId?: number
  buildNumber?: string
  commit?: string
}

export const staticApi = createApi({
  reducerPath: 'staticApi',
  baseQuery: fetchBaseQuery({ baseUrl: '/' }),
  endpoints: (builder) => ({
    getVersion: builder.query<Version, void>({
      query: () => `version.json?v=${new Date().getTime()}`,
    }),
  }),
})

export const {
  useGetVersionQuery
} = staticApi
